
import React from "react";
import { reactApi, reactElement } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Loading_Circle from "../public/assets/icons/Loading_Circle.svg";
import { ofArray } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export function LoadingPage() {
    let elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "h-full", "justify-center", "items-center"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["animate-[spin_1.5s_linear_infinite]", "text-primary", "h-10", "w-10"])], (elems = [Loading_Circle()], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

